import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import AzFilter from '~/components/_next/molecules/AzFilter.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
import { gtmPushEvent } from '~/helpers/gtm';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzSearchFilterNested',
  props: {
    subfacets: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useSearchFacets = useSearchFacets(),
      facets = _useSearchFacets.facets,
      addSearchFacet = _useSearchFacets.addSearchFacet,
      removeSearchFacet = _useSearchFacets.removeSearchFacet;
    var selectedSubfacet = ref();
    function onSubfacetClick(subfacet) {
      if (selectedSubfacet.value === subfacet.id) {
        selectedSubfacet.value = null;
      } else {
        selectedSubfacet.value = subfacet.id;
      }
    }
    var visibleSubfacets = computed(function () {
      return props.subfacets.filter(function (facet) {
        return !selectedSubfacet.value || selectedSubfacet.value === facet.id;
      });
    });
    function onFilterChange(_x, _x2, _x3) {
      return _onFilterChange.apply(this, arguments);
    }
    function _onFilterChange() {
      _onFilterChange = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(facetId, optionId, selected) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!selected) {
                _context.next = 6;
                break;
              }
              _context.next = 3;
              return addSearchFacet(facetId, optionId);
            case 3:
              gtmPushEvent('filter', {
                event: 'generic_event',
                event_category: 'engagement',
                event_action: 'click',
                event_label: 'filter',
                event_name: 'generic_event',
                filter: optionId
              });
              _context.next = 8;
              break;
            case 6:
              _context.next = 8;
              return removeSearchFacet(facetId, optionId);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onFilterChange.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      facets: facets,
      addSearchFacet: addSearchFacet,
      removeSearchFacet: removeSearchFacet,
      selectedSubfacet: selectedSubfacet,
      onSubfacetClick: onSubfacetClick,
      visibleSubfacets: visibleSubfacets,
      onFilterChange: onFilterChange,
      AzFilter: AzFilter,
      AzIcon: AzIcon
    };
  }
});